module.exports = __webpack_public_path__ + "static/ticket-b33d4df45afb0c560e0681bbaa8836e2.png";